import theme from '../../theme';

const ICON_SIZES = {
  small: {
    width: '18',
    height: '17',
  },
  medium: {
    width: '24',
    height: '24',
  },
};

const UserIcon = ({ color = theme.palette.text.secondary, size = 'medium' }) => {
  const dimensions = ICON_SIZES[size];

  return (
    <svg
      width={dimensions.width}
      height={dimensions.height}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.67383 16.8809H14.3174C16.2246 16.8809 17.209 15.8965 17.209 14.0156V3.31934C17.209 1.43848 16.2246 0.454102 14.3174 0.454102H3.67383C1.77539 0.454102 0.782227 1.42969 0.782227 3.31934V14.0156C0.782227 15.8965 1.77539 16.8809 3.67383 16.8809ZM2.53125 13.8574V3.47754C2.53125 2.625 2.97949 2.20312 3.78809 2.20312H14.2031C15.0029 2.20312 15.46 2.625 15.46 3.47754V13.8574C15.46 14.5166 15.1787 14.9209 14.6777 15.0703C13.8867 13.04 11.6631 11.6426 9 11.6426C6.33691 11.6426 4.10449 13.04 3.31348 15.0703C2.80371 14.9297 2.53125 14.5254 2.53125 13.8574ZM9 10.2363C10.6787 10.2451 11.9883 8.82129 11.9883 6.95801C11.9883 5.20898 10.6699 3.74121 9 3.74121C7.32129 3.74121 5.99414 5.20898 6.00293 6.95801C6.01172 8.82129 7.3125 10.2188 9 10.2363Z"
        fill={color}
      />
    </svg>
  );
};

export { ICON_SIZES };
export default UserIcon;
